import { z } from 'zod';

import { MAX_FEE_BASIS_POINTS } from '@/entities/client-billing-settings';

import { parseFeeBasisPoints } from '../lib/parse-fee-basis-points';

export const feePercentSchema: z.ZodType<string, string> = z.string().refine((text) => {
    const basisPoints = parseFeeBasisPoints(text);
    return basisPoints !== null && basisPoints <= MAX_FEE_BASIS_POINTS;
}, 'Enter valid number');
